import { getExternalProviders } from "@husky-hrc/Framework/Services/CustomIdentityService";
import Constants from "@husky-hrc/Utilities/Constants";
import { createHandlerChainRunner, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import { ExternalProviderLinkCollectionModel } from "@insite/client-framework/Services/IdentityService";

type Parameter = {
    returnUrl?: string;
};

type HandlerType = HandlerWithResult<Parameter, ExternalProviderLinkCollectionModel>;

export const DispatchBeginLoadExternalProvidersWithReturn: HandlerType = props => {
    props.dispatch({
        type: Constants.Actions.BeginLoadExternalProvidersWithReturn,
        id: props.parameter.returnUrl,
    } as any);
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.result = await getExternalProviders(props.parameter.returnUrl);
    } catch (error) {
        // Since this is on every page, we don't want to throw an error here.
        props.result = { externalProviders: [] };
    }
};

export const DispatchCompleteLoadExternalProvidersWithReturn: HandlerType = props => {
    props.dispatch({
        type: Constants.Actions.CompleteLoadExternalProvidersWithReturn,
        model: {
            id: props.parameter.returnUrl,
            externalProviders: props.result?.externalProviders,
        },
    } as any);
};

export const chain = [
    DispatchBeginLoadExternalProvidersWithReturn,
    RequestDataFromApi,
    DispatchCompleteLoadExternalProvidersWithReturn,
];

const loadExternalProvidersWithReturn = createHandlerChainRunner(chain, "LoadExternalProvidersWithReturn");
export default loadExternalProvidersWithReturn;
